.container {
    composes: container from '../billing-summary/coupon-pill.module.css';
    background-color: var(--info-bg);
    color: var(--info);
}
